var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.536,
    height: 93.891
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c52cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d37a2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.594 31.3h-4.471v-8.945A22.138 22.138 0 0 0 35.768 0a22.138 22.138 0 0 0-22.355 22.355V31.3H8.942A8.968 8.968 0 0 0 0 40.239v44.71a8.968 8.968 0 0 0 8.942 8.942h53.652a8.968 8.968 0 0 0 8.942-8.942v-44.71a8.968 8.968 0 0 0-8.942-8.939ZM35.768 71.536a8.942 8.942 0 1 1 8.942-8.942 8.968 8.968 0 0 1-8.942 8.942ZM49.628 31.3h-27.72v-8.945a13.86 13.86 0 0 1 27.72 0Z"
  })));
};
export default SvgLock;